
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.734 2.275a.906.906 0 0 0-1.284 0L8 6.717l-4.45-4.45a.906.906 0 1 0-1.284 1.282L6.716 8l-4.45 4.45a.906.906 0 1 0 1.283 1.284L8 9.284l4.45 4.45a.906.906 0 1 0 1.284-1.284L9.284 8l4.45-4.45a.912.912 0 0 0 0-1.275Z",
  fill: "#423F45"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\">\r\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.7338 2.27531C13.3788 1.92036 12.8055 1.92036 12.4505 2.27531L8 6.71672L3.54949 2.26621C3.19454 1.91126 2.62116 1.91126 2.26621 2.26621C1.91126 2.62116 1.91126 3.19454 2.26621 3.54949L6.71672 8L2.26621 12.4505C1.91126 12.8055 1.91126 13.3788 2.26621 13.7338C2.62116 14.0887 3.19454 14.0887 3.54949 13.7338L8 9.28328L12.4505 13.7338C12.8055 14.0887 13.3788 14.0887 13.7338 13.7338C14.0887 13.3788 14.0887 12.8055 13.7338 12.4505L9.28328 8L13.7338 3.54949C14.0796 3.20364 14.0796 2.62116 13.7338 2.27531Z\" fill=\"#423F45\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/close.ccef89fd5a99e365b60b416a57823e77.svg"),
        {
          React: SvgClose,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      